import {
  FETCH_ORDERS_FAILURE,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDER_FAILURE,
  FETCH_ORDER_SUCCESS,
  FETCH_ORDER_REQUEST,
  CACHE_ORDER_DETAIL,
} from '@store/order/actions';

import { LOGOUT } from '@store/guest/actions';

export const initialState = {
  orders: [],
  order: null,
  detailsById: {},
  isOrdersListFetching: false,
  isOrderFetching: false,
};

const guest = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case FETCH_ORDERS_REQUEST:
      return {
        ...state,
        isOrdersListFetching: true,
      };
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        isOrdersListFetching: false,
        orders: [],
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        isOrdersListFetching: false,
        orders: payload,
      };
    case FETCH_ORDER_REQUEST:
      return {
        ...state,
        isOrderFetching: true,
        order: null,
      };
    case FETCH_ORDER_FAILURE:
      return {
        ...state,
        isOrderFetching: false,
        order: null,
      };
    case FETCH_ORDER_SUCCESS:
      return {
        ...state,
        isOrderFetching: false,
        order: payload,
        detailsById:
          payload?.id != null ? { ...state.detailsById, [payload.id]: payload } : state.detailsById,
      };
    case CACHE_ORDER_DETAIL:
      return payload?.id != null
        ? { ...state, detailsById: { ...state.detailsById, [payload.id]: payload } }
        : state;
    case LOGOUT:
      return {
        ...initialState,
      };
    default: {
      return state;
    }
  }
};

export default guest;
